import Plausible from 'plausible-tracker';

const plausible = Plausible({
    domain: 'rp-one.eu',
    trackLocalhost: process.env.NODE_ENV === 'development',
});

export const { enableAutoPageviews, enableAutoOutboundTracking } = plausible;